import * as React from "react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { GLCheckbox } from "common/components";
import { useSelectedRows, useSelectedRowsDispatch } from "common/contexts";
import PathNav from "./PathNav";
import { WindowHeader } from "../styledComponents";
function PanelHeader({ repoRules, repo, repoPath, setRepoPath, setRepo }) {
  const { t } = useTranslation("enterprise_security_sigma");
  const selectedRules = useSelectedRows();
  const selectedRulesDispatch = useSelectedRowsDispatch();
  const ruleFiles = useMemo(() => repoRules.filter((rule) => rule.type === "file"), [repoRules]);
  const selectAll = (e) => {
    if (e.target.checked) {
      selectedRulesDispatch({ type: "add", payload: ruleFiles });
    } else {
      selectedRulesDispatch({ type: "remove", payload: ruleFiles });
    }
  };
  const allSelected = useMemo(
    () => ruleFiles.length > 0 && selectedRules.length > 0 && ruleFiles.every((rule) => !!selectedRules.find((sRule) => rule.id === sRule.id)),
    [ruleFiles, selectedRules]
  );
  return /* @__PURE__ */ React.createElement(WindowHeader, { "data-testid": "path-title" }, ruleFiles.length > 0 && /* @__PURE__ */ React.createElement(GLCheckbox, { checked: allSelected, onChange: selectAll, title: t("panel_header.select_all") }), /* @__PURE__ */ React.createElement(PathNav, { repo, repoPath, setRepoPath, setRepo }));
}
export default PanelHeader;
